import React from 'react';

const Page404 = () => {
  return(
      <>
        <div className="container-fluid wrapper">
		      <div className="container">
		      	<div className="row">
		      		<div className="col-12">
		        		<h1> Page not found! </h1>
		        	</div>
		        </div>
		      </div>
	      </div>
      </>
    );
};

export default Page404;